import React from "react";
import { connect } from "react-redux";
import BatchProcessingHistory from "../../../components/BatchProcessingHistory";
import { batchProcessingConfigs } from "../../../components/BatchProcessingHistory/configs";

const BatchProcessingOrderUploadHistory = (props) => {
  return (
    <BatchProcessingHistory
      {...props}
      config={batchProcessingConfigs.batchProcessingOrderUpload}
    />
  );
};

const mapState = ({ batchOrderReportUploadsList, session }) => {
  return {
    batchOrderReportUploadsList:
      batchOrderReportUploadsList?.batchOrderReportUploadsList || [],
    totalItems: batchOrderReportUploadsList?.totalItems || 0,
    user: session.user,
    fetching: batchOrderReportUploadsList?.fetching || false,
    fetched: batchOrderReportUploadsList?.fetched || false,
  };
};

export default connect(mapState)(BatchProcessingOrderUploadHistory);
